import React, { useState, useEffect, useCallback } from "react";
import Button from "../Button";
import IcClip from "../Svg/IcClip";
import { useDropzone } from "react-dropzone";
import style from "./style.module.scss";

export default function FileUpload(props) {
  const { files, setfiles, loading, label, hideButton = false, stacked = false } = props;

  const [fileDroped, setfileDroped] = useState();
  const onDropFile = useCallback(__files => {
    setfileDroped(
      __files.map(e =>
        Object.assign(e, {
          preview: URL.createObjectURL(e),
        }),
      ),
    );
  }, []);

  useEffect(() => {
    if (!!fileDroped) {
      const _files = (files || []).concat(fileDroped);
      setfiles(_files);
    }
    // Intentionally only re-runs when a new drop occurs; `files`/`setfiles` come from the parent
    // and can change reference on every render, and this effect doesn't reset `fileDroped` after
    // consuming it, so adding them would risk re-appending the same dropped file repeatedly.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fileDroped]);

  const { getRootProps, getInputProps } = useDropzone({
    accept: "image/*",
    multiple: true,
    maxFilesize: 20971520, // 20 MB
    onDrop: onDropFile,
  });

  return (
    <div className={`${style.container} ${stacked ? style.stacked : ""}`}>
      {!hideButton && (
        <Button loading={!!loading} type="submit" onClick={() => {}} {...getRootProps()} title="Anexar Arquivos">
          <input {...getInputProps()} />
          <IcClip />

          {!!label && <span className="ml-2">{label}</span>}
        </Button>
      )}
      <div className={`${style.files} ${stacked ? style.filesStacked : ""}`}>
        {files?.map((__file, __i) => (
          <span className={`${style.file} ${stacked ? style.fileStacked : ""}`} key={`${__file?.name}-${__i}`}>
            <span className={style.name}>{__file?.name}</span>
            <span
              className={style.remove_file}
              onClick={() => {
                let _files = [...files];
                _files.splice(__i, 1);
                setfiles(_files);
              }}
            >
              X
            </span>
          </span>
        ))}
      </div>
    </div>
  );
}
